import { Select } from '@platform/ui';

import { locales, useI18n, type Locale } from '../i18n';

/**
 * Language picker.
 *
 * Options are listed in their own language, which is what someone looking for
 * their language actually scans for. Adding a language to the registry makes it
 * appear here with no change to this component.
 */
export function LanguageToggle() {
    const { locale, setLocale, t } = useI18n();

    return (
        <Select
            size="sm"
            className="w-auto"
            value={locale}
            aria-label={t.common.language}
            onChange={(event) => setLocale(event.target.value as Locale)}
        >
            {(Object.keys(locales) as Locale[]).map((code) => (
                <option key={code} value={code}>
                    {locales[code].meta.nativeName}
                </option>
            ))}
        </Select>
    );
}
